var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-base',{attrs:{"pacifier":false},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Your Lawyer Was Unavailable")]},proxy:true},(_vm.hasCalendly)?{key:"subtitle",fn:function(){return [_vm._v("Schedule an appointment with your Unbundled Lawyer below:")]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }